module.exports = __webpack_public_path__ + "static/img/jjylzy1.995c2ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/jjylzy1.png
// module id = pFuz
// module chunks = 64